import { Flex, Tag, Tooltip } from 'antd'
import dayjs from 'dayjs'

import {
  NewbornInvestigationPeriodState,
  NewbornInvestigationPeriodStatusDto
} from 'src/api/requests'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

const PeriodStateColorMap: Record<NewbornInvestigationPeriodState, string> = {
  [NewbornInvestigationPeriodState.DONE]: 'success',
  [NewbornInvestigationPeriodState.REQUESTED]: 'warning',
  [NewbornInvestigationPeriodState.MISSING]: 'error',
  [NewbornInvestigationPeriodState.PLANNED]: 'default'
}

type Props = {
  period?: NewbornInvestigationPeriodStatusDto
}

export const NewbornPeriodStateTag = ({ period }: Props) => {
  const { t } = useLocales()

  if (!period?.status) return '-'

  const dueDate = period.dueDate
    ? dayjs(period.dueDate).format(dayMonthYearFormatWithDot)
    : null

  const resultDate = period.resultDate
    ? dayjs.utc(period.resultDate).tz().format(dayMonthYearFormatWithDot)
    : null

  const details = [
    period.status === NewbornInvestigationPeriodState.DONE && resultDate
      ? `${t('pregnancy.newborn_investigation_status.result_date')}: ${resultDate}`
      : null,
    period.resultTitle
      ? `${t('pregnancy.newborn_investigation_status.result')}: ${period.resultTitle}`
      : null,
    period.demandCode
      ? `${t('pregnancy.newborn_investigation_status.demand')}: ${period.demandCode}`
      : null,
    dueDate
      ? `${t('pregnancy.newborn_investigation_status.due_date')}: ${dueDate}`
      : null
  ].filter(Boolean)

  const label = t(
    `pregnancy.newborn_investigation_status.states.${period.status}`
  )

  return (
    <Tooltip
      title={
        details.length ? (
          <Flex vertical>
            {details.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </Flex>
        ) : null
      }
    >
      <Tag color={PeriodStateColorMap[period.status]}>
        {period.status === NewbornInvestigationPeriodState.PLANNED && dueDate
          ? `${label} · ${dueDate}`
          : label}
      </Tag>
    </Tooltip>
  )
}
